import AppState from '../../types/app-state'

import {Role} from '../../../values/Role'

export const rolesSelector = (state: AppState): Role[] => state.roles.roles

export const isFetchingRolesSelector = (state: AppState): boolean => state.roles.isFetching
